import React, { FC, useContext, useEffect, useState } from 'react'
import { FilterSet } from 'types/Option';
import SearchRow from 'components/SearchRow';
import FiltersAppliedPanel from 'components/FiltersAppliedPanel';
import MobileFilterPanel from 'components/MobileFilterPanel';
import DogList from 'components/dogList/DogList';
import FilterPanel from 'components/FilterPanel';
import { DataContext } from 'hooks/HeaderContext';
import ErrorAlert from 'components/ErrorAlert';
import { CustomView } from 'types/CustomView';
import { FILTER_KEY, FILTER_TYPE } from 'types/Dog';
import equal from 'fast-deep-equal/es6';

const isAnyFilterApplied = (f: FilterSet, customView: CustomView) => {
    return (!customView && !!Object.values(f).flat().length)
        ||
        (customView && Object.keys(f).some(filterType => filterType !== FILTER_KEY[FILTER_TYPE.INSTITUTION] && f[filterType].length > 0))
};


const DogListView: FC = () => {

    const [showMobileFilterPanel, setShowMobileFilterPanel] = useState(false);
    const toggleMobileFilterPanel = () => setShowMobileFilterPanel(o => !o);

    useEffect(() => {
        document.title = 'Puppies For Parole'
    }, [])


    const {
        filteredDogsList,
        dogListError,
        selectedFilters,
        loading,
        customView,
    } = useContext(DataContext)


    return (
        <section id="dogs">
            {!loading && !dogListError &&
                <div className="container-lg pt-4 d-md-flex">
                    <div className="d-none d-lg-flex col-lg-3 pe-3" id="" style={{ maxWidth: '25%' }}>
                        <FilterPanel />
                    </div>
                    <div className='d-lg-none'>
                        <MobileFilterPanel
                            showMobileFilterPanel={showMobileFilterPanel}
                            toggleMobileFilterPanel={toggleMobileFilterPanel}
                        />
                    </div>
                    <div className="col col-lg-9">
                        <div className='d-lg-none'>
                            <SearchRow setShowMobileFilterPanel={setShowMobileFilterPanel} />
                        </div>
                        {(isAnyFilterApplied(selectedFilters, customView)) &&
                            <FiltersAppliedPanel />
                        }
                        <div id="mobileFilterRow" className="container-lg mt-2"></div>
                        {!dogListError && filteredDogsList &&
                            <DogList />
                        }
                    </div>
                </div>
            }
            {!loading && dogListError &&
                <div className='container-lg'>
                    <ErrorAlert error={dogListError} showAlert={true} alertType={'danger'} />
                </div>
            }
        </section >
    )
}

export default DogListView;